<template>
  <div id="form-depot-choix" class="mb-6">
    <LimiteDepotSection :categories="categories" :period="period" :content="content" />
  </div>
</template>

<script>
import LimiteDepotSection from '@/components/formulaire/compte/LimiteDepotSection';

export default {
  name: 'LimiteDepot',
  components: { LimiteDepotSection },
  props: {
    content: { type: Object, required: true },
    metadata: { type: Object },
  },
  data() {
    return {
      categories: ['deposit', 'time', 'loss'],
      period: 'week',
      limits: {},
    };
  },
};
</script>
